import { EventFacetName, targetAudiences } from "@libry-content/common";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { useEventsListContext } from "./EventFilterContext";

export const useResolvedEventFacets = () => {
  const { t, ts } = useTranslation();
  const { facets, urlState } = useEventsListContext();

  return {
    libraries: resolveFacet({
      label: t("Bibliotek"),
      facets: facets?.libraries,
      facetToFilter: (library) => ({
        label: ts(library.name)!,
        value: library.slug!,
      }),
      urlState: urlState?.libraries,
    }),
    eventTypes: resolveFacet({
      label: t("Kategori"),
      facets: facets?.eventTypes,
      facetToFilter: (eventType) => ({
        label: ts(eventType.label)!,
        value: ts(eventType.label)!,
      }),
      urlState: urlState?.eventTypes,
    }),
    targetAudiences: resolveFacet({
      label: t("Målgruppe"),
      facets: facets?.targetAudiences,
      facetToFilter: (targetAudienceCode) => ({
        label: ts(targetAudiences[targetAudienceCode])!,
        value: targetAudienceCode!,
      }),
      urlState: urlState?.targetAudiences,
    }),
  } satisfies ResolvedEventFacets;
};

const resolveFacet = <Facet>(props: {
  label: string;
  facets?: Facet[];
  facetToFilter: (facet: Facet) => EventListFilter;
  urlState?: string[];
}) => {
  const filters = props.facets?.map(props.facetToFilter);

  return {
    availableFilters: filters || [],
    currentFilters: filters?.filter((filter) => props.urlState?.includes(filter.value)) || [],
    label: props.label,
  };
};

export type ResolvedEventFacets = Facets<EventFacetName>;

export type Facets<A extends string> = Record<
  A,
  { label: string; currentFilters: EventListFilter[]; availableFilters: EventListFilter[] }
>;

export type EventListFilter = { label: string; value: string };
